import { Navbar } from './Navbar';
import Footer from './Footer';
import WhatsNewModal from './WhatsNewModal';
import { I4AssistantWidget } from '../assistant/I4AssistantWidget';
import { useAuth } from '../../context/AuthContext';

export const Layout = ({ children }) => {
  const { canRead } = useAuth();

  return (
    <div className="layout-main">
      <Navbar />
      <main className="mx-auto max-w-[1600px] px-4 sm:px-6 lg:px-8 py-6 pb-16">
        {children}
      </main>
      <Footer />
      <WhatsNewModal />
      {canRead('ai.ibi') && <I4AssistantWidget />}
    </div>
  );
};
